import React, { FC, useContext } from 'react';
import { Anchor, H3, MessageBox, P1, PrimaryButton } from '@zooplus/ui-components';
import { useTranslation } from 'react-i18next';
import { OrderStatus, OrderStatusesMapping, ParcelStatusesMapping } from './model/OrderStatus';
import './order-status.css';
import Loader from '../../loader/Loader';
import { ExperimentationContext, UserTrackingEvents } from '../../context/ExperimentationContext';

type OrderStatusDetailsProps = {
  setOrderStatusDetailsWasDisplayed: React.Dispatch<React.SetStateAction<boolean>>;
  orderStatus: OrderStatus;
  parcelStatusLoading: boolean;
};

const OrderStatusDetails: FC<OrderStatusDetailsProps> = (props) => {
  const { t } = useTranslation();
  const experimentation = useContext(ExperimentationContext);
  return (
    <div data-test="contactForm.orderStatus" className="orderStatus">
      <Loader
        data-test="contactForm.orderStatus.loader"
        isLoading={props.parcelStatusLoading}
        variant="zooplus">
        <div className="orderStatus__grid">
          {props.orderStatus &&
            Object.keys(OrderStatusesMapping).includes(
              (props.orderStatus.status as string).toUpperCase(),
            ) && (
              <>
                <MessageBox variant="success">
                  <H3 className="orderStatus__title">
                    {t(`form.order_status.${OrderStatusesMapping[props.orderStatus.status]}`)}
                  </H3>
                  {props.orderStatus.status !== 'SHIPPING' &&
                    props.orderStatus.status !== 'DELIVERED' && (
                      <p>
                        {t(
                          `form.order_status.${
                            OrderStatusesMapping[props.orderStatus.status]
                          }_subtitle`,
                        )}
                      </p>
                    )}
                  {props.orderStatus.parcels && (
                    <ul className="orderStatus__details">
                      {props.orderStatus.parcels.map((parcel, index, array) => (
                        <li>
                          <h4 className="orderStatus__details-title">
                            {t('form.order_status.parcel_number', {
                              index: index + 1,
                              length: array.length,
                            })}
                          </h4>
                          {/* @ts-ignore */}
                          <div className="orderStatus__parcelStatus">
                            {t(`form.order_status.${ParcelStatusesMapping[parcel.status]}`)}
                          </div>
                          <div>
                            <Anchor href={parcel.trackingLink} target="_blank" rel="noreferrer">
                              {t('form.order_status.tracking_link')}
                            </Anchor>
                          </div>
                        </li>
                      ))}
                    </ul>
                  )}
                </MessageBox>
                <div className="orderStatus__footer">
                  <P1>{t('form.order_status.more_help_question')}</P1>
                  <PrimaryButton
                    size="small"
                    data-test="contactForm.orderStatus.moreHelpButton"
                    onClick={() => {
                      props.setOrderStatusDetailsWasDisplayed(true);
                      experimentation.trackClick(
                        UserTrackingEvents.CF_ORDER_AND_PARCEL_DELIVERY_STATUS_DISPLAYED_NEED_MORE_HELP,
                      );
                    }}>
                    {t('form.order_status.more_help_button')}
                  </PrimaryButton>
                </div>
              </>
            )}
        </div>
      </Loader>
    </div>
  );
};

export default OrderStatusDetails;
